import { Navigate, useSearchParams } from "react-router-dom";
import Hero from "../component/Hero";
import CourseCategory from "../sections/CourseCategory";
import CoursesGrid1 from "../sections/CoursesGrid1";
import CoursesRowWithAction from "../sections/CoursesRowWithAction";
import LogoRow from "../sections/LogoRow";
import TestimonialRow from "../sections/TestimonialRow";
import LoginFormModal from "../component/LoginFormModal";
import RegisterationFormModal from "../component/RegistrationFormModal";
import { Helmet } from "react-helmet";
import ErrorBoundaryWrap from "../error-boundries/ErrorBoundaryWrap";

import MarqueeHome from "../component/Marquee";
import CoursesGrid2 from "../sections/CoursesGrid2";
import CoursesGrid3 from "../sections/CoursesGrid3";
import HeroBanner from "../component/HeroBanner";
import Faculties from "../component/Faculties";
import SampleCertificate from "../sections/SampleCertificate";
import { useEffect, useState } from "react";
import AxiosClient from "../client/AxiosClient";
import { API_HOME_META } from "../ApiEndPoints";
import HeroBanner3 from "../component/HeroBanner3";
import YoutubeVideoGrid from "../sections/YoutubeVideoGrid";
import CompetetiveExams from "../sections/CompetetiveExams";
import CompetetiveExamsAd from "../sections/CompetetiveExamsAd";

export default function HomePage() {
  const [searchParams] = useSearchParams();
  const action = searchParams.get("action");

  return (
    <main>
      <HomeMeta />
      <ErrorBoundaryWrap component={HeroBanner3} />
      <ErrorBoundaryWrap component={MarqueeHome} />
      <ErrorBoundaryWrap component={CoursesGrid1} />
      <ErrorBoundaryWrap component={CompetetiveExamsAd} />

      <ErrorBoundaryWrap component={CoursesGrid2} />
      {/* <ErrorBoundaryWrap component={CoursesGrid3} /> */}

      {/* <ErrorBoundaryWrap component={LogoRow} /> */}
      <ErrorBoundaryWrap component={SampleCertificate} />
      <ErrorBoundaryWrap component={CoursesRowWithAction} />
      {/* <ErrorBoundaryWrap component={CourseCategory} /> */}
      <ErrorBoundaryWrap component={Faculties} />
      <ErrorBoundaryWrap component={TestimonialRow} />

      <YoutubeVideoGrid />

      {action === "login" && <Navigate to="/login" />}
      {action === "register" && <Navigate to="/register" />}
    </main>
  );
}

function HomeMeta() {
  const [homeMeta, setHomeMeta] = useState(null);

  useEffect(() => {
    AxiosClient.get(`${API_HOME_META}`)
      .then((response) => {
        const data = response.data.data;

        setHomeMeta(data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  }, []);

  return (
    <Helmet>
      <title>{homeMeta?.meta_title || "IALM"}</title>

      <meta name="keywords" content={homeMeta?.meta_keywords} />
      <meta name="description" content={homeMeta?.meta_description} />
    </Helmet>
  );
}
